// @ts-nocheck

export const localeCodes =  [
  "en",
  "ru"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_07719c1c",
      load: () => import("#nuxt-i18n/07719c1c" /* webpackChunkName: "locale_en_46json_07719c1c" */),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_a63e989d",
      load: () => import("#nuxt-i18n/a63e989d" /* webpackChunkName: "locale_ru_46json_a63e989d" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "ru",
    name: "Russian",
    language: undefined
  }
]

